import fp from 'lodash/fp';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { host } from '@deerplusofficial/pos-helper';
import { ButtonBase, Icon } from '@deerplusofficial/pos-components';
import { withClient } from '@deerplusofficial/pos-hoc';
import actions from '../../actions';

const Container = styled(ButtonBase)`
  color: #ffffff;
`;

const Inner = styled.div`
  display: flex;
  align-items: center;
`;

const Arrow = styled(Icon).attrs({ icon: 'chevron-left', size: 'lg' })`
  margin-right: 11px;
`;

class Topbar extends PureComponent {
  static propTypes = {
    withLogout: PropTypes.bool,
  };

  static defaultProps = {
    withLogout: false,
  };

  onClick = async () => {
    const {
      withLogout,
      resetUser,
      client: { onLogout },
    } = this.props;

    if (withLogout) {
      await onLogout();
      resetUser();
      return;
    }

    window.location.href = host.admin;
  };

  render() {
    const { withLogout } = this.props;

    return (
      <Container onClick={this.onClick}>
        <Inner>
          <Arrow />
          {withLogout ? '登出' : '返回營運後台'}
        </Inner>
      </Container>
    );
  }
}

const { reset: resetUser } = actions.user;

export default fp.compose(
  withClient(),
  connect(
    null,
    { resetUser }
  )
)(Topbar);



// WEBPACK FOOTER //
// ./src/pages/Login/Topbar.js